import { backupOption } from "../datastoreFilters";
import { filterName } from "../utils";
import {
  areAllFiltersNotApplied,
  areHighRisksApplied,
  createEmptyFilters,
  highRisksOptions,
} from "./utils";

export const getDatastoreSmartFiltersInfo = (
  appliedFilters,
  setAppliedFilters
) => {
  const missingBackupApplied =
    appliedFilters[filterName.BACKUP]?.[backupOption.DISABLED] &&
    !appliedFilters[filterName.BACKUP]?.[backupOption.ENABLED];

  return [
    {
      text: "Database at high risk missing backup",
      applied:
        missingBackupApplied &&
        areHighRisksApplied(appliedFilters) &&
        areAllFiltersNotApplied({
          appliedFilters: appliedFilters,
          excludedFilterNames: [filterName.RISK, filterName.BACKUP],
        }),
      onClick: () => {
        const updatedFilters = createEmptyFilters(appliedFilters);
        highRisksOptions.forEach((risk) => {
          updatedFilters[filterName.RISK][risk] = true;
        });
        updatedFilters[filterName.BACKUP] = {
          [backupOption.DISABLED]: true,
        };
        setAppliedFilters(updatedFilters);
      },
    },
  ];
};
